import React from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

const RoadMap = ({ heading, description, roadMapsteps, roadMapHeading }) => {

  const { t } = useTranslation("roadMapCommonContent")
  const mainHeading = t("mainHeading", { returnObjects: true })
  const sectionDescription = t("sectionDescription", { returnObjects: true })
  const roadMapHeading0 = t("roadMapHeading0", { returnObjects: true })
  const roadMapDescription0 = t("roadMapDescription0", { returnObjects: true })
  const roadMapHeading1 = t("roadMapHeading1", { returnObjects: true })
  const roadMapDescription1 = t("roadMapDescription1", { returnObjects: true })
  const roadMapHeading2 = t("roadMapHeading2", { returnObjects: true })
  const roadMapDescription2 = t("roadMapDescription2", { returnObjects: true })
  const roadMapHeading3 = t("roadMapHeading3", { returnObjects: true })
  const roadMapDescription3 = t("roadMapDescription3", { returnObjects: true })

  return (
    <>
      <div className="road-map-box ai-page-roadmap">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="engagment-model-text">
                {heading || mainHeading}
              </h1>
              <h3 className="sub-heading">
                {description || sectionDescription}{" "}
              </h3>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="prover-box-map-left ">
                <div className="proven-roadmap-text road-map-left-space second">
                  <h2>{roadMapHeading[1] || roadMapHeading0}</h2>
                  <p className="common-text">
                    {roadMapsteps[1] || roadMapDescription0}
                  </p>
                </div>

                <div className="proven-roadmap-text forth">
                  <h2>{roadMapHeading[2] || roadMapHeading1}</h2>
                  <p className="common-text">
                    {roadMapsteps[2] || roadMapDescription1}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 position-relative none-tab-imge">
              <div className="road-image-box ai-development-road-map">
                <img
                  className="none-tab"
                  src="/images/roadmap-fff.svg"
                  alt="Roadmap"
                />
                <img
                  className="none-web-box"
                  src="/images/roadmap-tablet/roadmap4-tab.png"
                  alt="Roadmap"
                />
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="right-box-text ">
                <div className="proven-roadmap-text road-map-left-space first">
                  <h2>{roadMapHeading[0] || roadMapHeading2}</h2>
                  <p className="common-text">
                    {roadMapsteps[0] || roadMapDescription2}
                  </p>
                </div>

                <div className="proven-roadmap-text third">
                  <h2>{roadMapHeading[3] || roadMapHeading3}</h2>
                  <p className="common-text">
                    {roadMapsteps[3] || roadMapDescription3}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoadMap;
